import styled from "styled-components";

import { getTheme, themed, Flow, Stream, Input, Dropdown, Typography, } from "@bracket/ui";
	import { useSwap, } from "@store";

import type { TokenDefinition, } from "@bracket/chainography";
import type { FunctionComponent, } from "react";



export declare type TokenAmountInputProps = {
	disabled?: boolean;
};



/**
 * A component that combines a token selector dropdown with an amount input field.
 * Used for entering token amounts in swap/trade interfaces.
 * 
 * @component
 * @param {Object} props - Component props
 * @param {boolean} [props.disabled=false] - Whether the input is disabled
 * @returns {JSX.Element} A token amount input component
 */
export const TokenAmountInput: FunctionComponent<TokenAmountInputProps> = ({
	disabled = false,
}) => {
	themed();

	const { tokenIn, tokensIn, amountIn, onTokenInChange, onTokenInAmountChange, } = useSwap();

	return (
		<InputContainer>
		{
			tokensIn.length && onTokenInChange ? (
				<Dropdown<TokenDefinition>
					items={tokensIn}
					selectedItem={tokenIn}
					onSelect={onTokenInChange}
					disabled={disabled}
					renderItem={token => {
						return (
							<>
								<ImageBrace $url={`url(${token.logoURI})`} />
								<Typography variant="paragraphMD">{token.symbol}</Typography>
							</>
						);
					}}
					renderSelectedItem={token => (
						<>
							<ImageBrace $url={`url(${token?.logoURI})`} />
							<Typography variant="paragraphMD">{token?.symbol}</Typography>
						</>
					)}
				/>
			) : null}
			<StyledInput value={amountIn} onChange={onTokenInAmountChange} disabled={disabled} type="text" />
		</InputContainer>
	);
};

const ImageBrace = styled(Flow)<{ $url: string; }>`
	width: 24px;
	height: 24px;
	margin-right: 8px;
	background-image: ${props => props.$url};
	background-size: contain;
	align-items: center;
	justify-content: center;
	background-repeat: no-repeat;
`;

const InputContainer = styled(Stream)`
	background-color: ${() => getTheme().surface_container};
	border-radius: 8px;
	overflow: hidden;
	height: 88px;
	align-items: center;
`;

const StyledInput = styled(Input)`
	margin-left: -350px;
	/* Ensure decimal separator is always a period */
	&::-webkit-inner-spin-button,
	&::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`;
